import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHero, Reveal, SectionEyebrow } from "@/components/Primitives";
import SEO from "@/lib/seo";
import { ArrowUpRight, Users } from "lucide-react";

export default function Authors() {
  const [authors, setAuthors] = useState([]);
  useEffect(() => { api.get("/authors").then((r) => setAuthors(r.data)); }, []);

  return (
    <div data-testid="authors-page">
      <SEO title="Fellows & Authors · The Cleanability Institute" description="The people writing the discipline of cleanability." path="/authors" />
      <PageHero
        testId="authors-hero"
        eyebrow="Fellows & authors"
        title="The people writing the discipline."
        lead="Researchers, practitioners and standards bodies whose work shapes cleanability as a field. Each profile collects their books, papers, essays and standards contributions."
      />
      <section className="container-x section-y border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {authors.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.04}>
              <Link to={`/authors/${a.slug}`} data-testid={`author-${a.slug}`} className="rounded-2xl border border-border bg-card p-7 md:p-8 hover-lift h-full group block">
                <Users className="h-5 w-5 text-[hsl(var(--accent))]" />
                <div className="mt-6 font-display text-xl md:text-2xl font-medium tracking-tight">{a.name}</div>
                <div className="mt-1 text-xs font-mono-mini text-muted-foreground uppercase">{a.tier} · {a.role}</div>
                <p className="mt-4 text-sm text-muted-foreground leading-relaxed line-clamp-4">{a.bio}</p>
                <div className="mt-6 inline-flex items-center gap-1.5 text-xs font-medium underline-link">
                  View profile <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
